import { render } from "./RegisterWelcome.vue?vue&type=template&id=654e14c2"
import script from "./RegisterWelcome.vue?vue&type=script&lang=js"
export * from "./RegisterWelcome.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__